<template>
  <v-container class="mt-4 px-5" fluid>
    <v-card class="shadowCard">
      <v-card-title primary-title class="text-subtitle-1">
        CEAA - FAST 2026
        <v-spacer></v-spacer>
        <v-btn
          color="blue-grey"
          class="white--text"
          small
          tile
          :href="imagen"
          download="CEAA-FAST-2026.jpg"
          target="_blank"
        >
          Descargar
          <v-icon right dark>mdi-cloud-download</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row justify="center">
          <v-col cols="12" md="8" lg="6">
            <v-img :src="imagen" contain alt="Convenio FAST + CEAA 2026" />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
  import imagen from '@/assets/docs2026/ceaa-fast-2026.jpg'

  export default {
    data() {
      return { imagen }
    },
  }
</script>
